export const ICON_PADDING = '2px';